import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "icon",
  viewBox: "0 0 1025 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M927.544 772.194V251.806a127.86 127.86 0 1 0-155.35-155.35H251.808a127.86 127.86 0 1 0-155.35 155.35v520.388a127.86 127.86 0 1 0 155.35 155.35h520.388a127.86 127.86 0 1 0 155.349-155.35m-155.35 91.42H251.808a127.86 127.86 0 0 0-91.42-91.42V251.806a127.86 127.86 0 0 0 91.42-91.42h520.388a127.86 127.86 0 0 0 91.42 91.42v520.388a127.86 127.86 0 0 0-91.42 91.42M895.58 64.492a63.93 63.93 0 1 1-63.93 63.93 63.93 63.93 0 0 1 63.93-63.93m-831.087 63.93a63.93 63.93 0 1 1 63.93 63.93 63.93 63.93 0 0 1-63.93-63.93m63.93 831.086a63.93 63.93 0 1 1 63.93-63.93 63.93 63.93 0 0 1-63.93 63.93m767.157 0a63.93 63.93 0 1 1 63.93-63.93 63.93 63.93 0 0 1-63.93 63.93" }, null, -1),
    _createElementVNode("path", { d: "M671.825 320.21H352.176a31.965 31.965 0 0 0 0 63.93h127.86v287.684a31.965 31.965 0 0 0 63.93 0V384.14h127.859a31.965 31.965 0 0 0 0-63.93" }, null, -1)
  ])))
}
export default { render: render }